import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const trashProjectsDirectoryRoute: InvariantJiraRoute = {
	name: 'trash-projects-directory',
	path: '/jira/settings/projects/trash',
	exact: true,
};
